export default "__VITE_ASSET__DXaGDxat__"